import { computed, action } from "mobx";
import { RacingStore, PageMethodsComposite, BranchViewEventsType, RacingEventTypes, RacingEventStatusType, RacingMasterEventInfo, RacingEventInfo } from "../../../data";
import { LeagueEventsCompositeModel, BranchViewEventModel } from "../data";
import { LeagueInfo } from "sb-resp-lib";

export class RacingCurrentEventsData {
    public provider: PageMethodsComposite;
    public racingStore: RacingStore;
    selectedType!: BranchViewEventsType;
    racingGameNavigation: any;
    constructor(provider: PageMethodsComposite, racingGameNavigation: Function) {
        this.provider = provider;
        this.racingStore = RacingStore.getInstance;
        this.racingStore.webMethods = {
            pageMethods: provider.pageMethods,
            racingPageMethods: provider.racingPageMethods
        };

        this.racingGameNavigation = racingGameNavigation;
    }

    // TODO: Remove when new event view is available
    openRacingGame(
        racecardId: number,
        regionId: number,
        mode: BranchViewEventsType,
        branchId: number,
        trapMarketId: number,
        bettingWithoutFavId: number,
        bettingWithoutTwoFavId: number,
        placeOnlyId: number,
        matchBettingId: number,
        toteId: number,
        totePlaceOnlyId: number,
        auPlaceOnlyId: number,
        event: any): void {
        this.racingGameNavigation(
            event,
            racecardId,
            regionId,
            mode,
            branchId,
            trapMarketId,
            bettingWithoutFavId,
            bettingWithoutTwoFavId,
            placeOnlyId,
            matchBettingId,
            toteId,
            totePlaceOnlyId,
            auPlaceOnlyId
        );
    }

    @computed get branchViewLeagueEvents(): LeagueEventsCompositeModel[] {
        let sortedLeagues = this.racingStore.sortedLeagues;
        let branchViewLeaguesEventsArr = new Array<LeagueEventsCompositeModel>();

        /* istanbul ignore next */
        for (let league of sortedLeagues) {
            let hasLiveStream: boolean = false;
            let masterEventsPerLeague = this.racingStore.filteredEventsByLeagueID(this.selectedType, league.masterLeagueId);

            /* istanbul ignore next */
            if (masterEventsPerLeague.length === 0) { continue; }
            let currBranchViewLeagueEvent = new LeagueEventsCompositeModel({ id: league.id, leagueName: league.name, hasLiveStream: false, events: [] });

            /* istanbul ignore next */
            for (let masterEvent of masterEventsPerLeague) {
                let currBranchViewEvent = new BranchViewEventModel({
                    id: masterEvent.id,
                    dateTime: masterEvent.date,
                    url: this.getUrl(masterEvent, league),
                    raceProgress: masterEvent.raceProgress,
                    handler: this.openRacingGame.bind(
                        this,
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.RaceCard),
                        this.racingStore.regionId,
                        this.selectedType,
                        Number(this.racingStore.branch.id),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.TrapMarket),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.BettingWithoutFav),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.BettingWithoutTwoFav),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.PlaceOnly),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.MatchBetting),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRTote),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRTotePlaceOnly),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRPlaceOnly)
                    )
                });

                currBranchViewLeagueEvent.events.push(currBranchViewEvent);
                hasLiveStream = hasLiveStream || masterEvent.racingEvents.some(this.hasLiveStream);
            }
            currBranchViewLeagueEvent.hasLiveStream = hasLiveStream
            branchViewLeaguesEventsArr.push(currBranchViewLeagueEvent);
        }

        return branchViewLeaguesEventsArr;
    }

    getUrl(masterEvent: RacingMasterEventInfo, league: LeagueInfo) {
        return masterEvent.raceProgress !== RacingEventStatusType.IsResult
            ? this.racingStore.getMasterRacingEventUrl(masterEvent, league)
            : "javascript:void();";
    }

    /* istanbul ignore next */
    hasLiveStream(element: RacingEventInfo) {
        return element && element.hasLiveStream === true;
    }

    /* istanbul ignore next */
    @action setParams(eventType: number, regionId: number, branchId: number) {
        this.selectedType = eventType;

        /* istanbul ignore next */
        if (regionId && branchId) {
            /* istanbul ignore next */
            this.racingStore.setParams(regionId, branchId);
        }
    }
}